import * as React from "react";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

import NavigateBefore from "@material-ui/icons/NavigateBefore";
import NavigateNext from "@material-ui/icons/NavigateNext";

import { PageHeader } from "../PageWrapper/PageHeader";
import { Iris } from "../Iris";

import steve from "../../images/steve.jpg";
import miles from "../../images/miles.jpg";
import kevin from "../../images/kevin.jpg";
import shane from "../../images/shane.jpg";
import laszlo from "../../images/laszlo.jpg";
import lionel from "../../images/lionel.jpg";

interface Testimonial {
  name: string;
  title: string;
  image: string;
  text: string | JSX.Element;
}

const DATA: Testimonial[] = [
  {
    name: "Steve Sohmer",
    title: "Best-selling author & producer",
    image: steve,
    text:
      "The magic of this software is that it can actually give you " +
      "line-by-line readings of things that should be revised. Touching the " +
      "low points in the graphs brings up actual quotes from the " +
      "manuscripts. It's like receiving an MRI of your manuscript.",
  },
  {
    name: "Shane Joseph",
    title: "Multi-published author and indie publisher",
    image: shane,
    text:
      "Iris is a powerful aid to authors and publishers " +
      "in assessing a manuscript's potential compared to the canon of published literature " +
      "from the last 10 years. As one of the founders says, " +
      "'It is like seeking the wisdom of someone who has read two million books.'",
  },
  {
    name: "Kevin Firkins",
    title: "TV producer & author",
    image: kevin,
    text:
      "Thank you for the opportunity to have my manuscript assessed. " +
      "The results were fascinating and have given me much to think about.",
  },
  {
    name: "Miles Hunt",
    title: "Author - The Information Editor",
    image: miles,
    text:
      "An invaluable tool to underpin the future of " +
      "creative writing by authors of all abilities, publishers will gain an " +
      "edge in focusing editorial attention on works in the best shape possible.",
  },
  {
    name: "Laszlo de Brissac",
    title: "Author - The Night Streamer",
    image: laszlo,
    text:
      "Quantification Iris has been the perfect partner to understand the " +
      "strength and weakness of my story! It was so rewarding seeing my overall " +
      "score climb from 72 to 81 through iterative improvements.",
  },
  {
    name: "Lionel Ross",
    title: "Proprietor i2i Publishing",
    image: lionel,
    text:
      "On my trial I was thoroughly impressed by both the speed and the amount of " +
      "information that Quantification supplied. I expected a great proof-read and " +
      "edit to transform a rough manuscript into a print-ready PDF, but what I " +
      "received was so much more. An assessment of commercial viability and even " +
      "a forecast of likely sales And where and how! This is a brilliant system.",
  },
];

export interface Props {
  showHeader?: boolean;
}

export const Testimonials = (props: Props) => {
  const { showHeader } = props;

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"), {
    defaultMatches: true,
  });

  const firstIndex = Math.floor(Math.random() * DATA.length);

  const [index, setIndex] = React.useState(firstIndex);
  const [manual, setManual] = React.useState(false);

  const onNextIndex = () => {
    setIndex(index === DATA.length - 1 ? 0 : index + 1);
  };
  const onPreviousIndex = () => {
    setIndex(index === 0 ? DATA.length - 1 : index - 1);
  };

  React.useEffect(() => {
    if (manual) {
      return;
    }

    const interval = setInterval(() => {
      onNextIndex();
    }, 10000);

    return () => clearInterval(interval);
  }, [index]);

  return (
    <Box>
      {showHeader === true && (
        <PageHeader
          title="Trusted across the industry"
          subtitle={
            <>
              Authors, publishers and agents across ther globe use <Iris /> to
              assess their manuscripts. <br />
              Here's what they have to say.
            </>
          }
        />
      )}
      <Grid
        container={true}
        spacing={4}
        direction={isSm ? "row" : "column-reverse"}
      >
        <Grid item={true} container={true} xs={12} sm={9}>
          <Box
            mb={1}
            textAlign={isSm ? "left" : "center"}
            display="flex"
            flexDirection="column"
          >
            <Box flexGrow={1}>
              <Typography variant="h6" gutterBottom={true}>
                {DATA[index].text}
              </Typography>
            </Box>
            <Box flexGrow={0} marginTop={{ xs: 2, sm: 4 }} display="flex">
              <Box flexGrow={1}>
                <Typography variant="h6" style={{ fontWeight: 700 }}>
                  {DATA[index].name}
                </Typography>
                <Typography variant="body1" color="textSecondary">
                  {DATA[index].title}
                </Typography>
              </Box>
              <Box flexGrow={0} minWidth={96}>
                <IconButton
                  onClick={() => {
                    setManual(true);
                    onPreviousIndex();
                  }}
                >
                  <NavigateBefore />
                </IconButton>
                <IconButton
                  onClick={() => {
                    setManual(true);
                    onNextIndex();
                  }}
                >
                  <NavigateNext />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item={true} container={true} xs={12} sm={3}>
          <Box width="100%" textAlign={isSm ? "right" : "center"}>
            <img
              src={DATA[index].image}
              alt={DATA[index].name}
              height={200}
              width={200}
              loading="lazy"
              style={{
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/Testimonials/Testimonials.tsx